export default "__VITE_ASSET__233091b9__"